import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 51 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "25.667",
      cy: "25",
      r: "24.456",
      fill: "#FCFEFF",
      stroke: "#83B9FF",
      "stroke-dasharray": "4.35 4.35",
      "stroke-width": "1.087"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M30.417 16.56V15c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5h-6.5V15c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.56c-2.7.25-4.01 1.86-4.21 4.25-.02.29.22.53.5.53h16.92c.29 0 .53-.25.5-.53-.2-2.39-1.51-4-4.21-4.25"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M33.667 22.84c.55 0 1 .45 1 1V30c0 3-1.5 5-5 5h-8c-3.5 0-5-2-5-5v-6.16c0-.55.45-1 1-1z",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M22.167 28c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71s.11-.52.29-.71c.28-.28.72-.37 1.09-.21q.195.075.33.21c.18.19.29.45.29.71s-.11.52-.29.71c-.19.18-.45.29-.71.29m3.5 0c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71s.11-.52.29-.71q.135-.135.33-.21c.37-.16.81-.07 1.09.21.18.19.29.45.29.71s-.11.52-.29.71l-.15.12q-.09.06-.18.09-.09.045-.18.06c-.07.01-.13.02-.2.02m3.5 0c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71s.11-.52.29-.71c.1-.09.2-.16.33-.21.18-.08.38-.1.58-.06q.09.015.18.06.09.03.18.09l.15.12c.18.19.29.45.29.71s-.11.52-.29.71l-.15.12q-.09.06-.18.09-.09.045-.18.06c-.07.01-.14.02-.2.02m-7 3.5c-.13 0-.26-.03-.38-.08-.13-.05-.23-.12-.33-.21-.18-.19-.29-.45-.29-.71s.11-.52.29-.71c.1-.09.2-.16.33-.21.18-.08.38-.1.58-.06q.09.015.18.06.09.03.18.09l.15.12c.18.19.29.45.29.71s-.11.52-.29.71c-.05.04-.1.09-.15.12q-.09.06-.18.09-.09.045-.18.06c-.07.01-.13.02-.2.02m3.5 0c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71s.11-.52.29-.71c.37-.37 1.05-.37 1.42 0 .18.19.29.45.29.71s-.11.52-.29.71c-.19.18-.45.29-.71.29m3.5 0c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71s.11-.52.29-.71c.37-.37 1.05-.37 1.42 0 .18.19.29.45.29.71s-.11.52-.29.71c-.19.18-.45.29-.71.29"
    }, null, -1)
  ]))]))
}
export default { render: render }